import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import ElementUI from 'element-ui'
import Vant from 'vant'
import 'font-awesome/css/font-awesome.min.css'
// import 'element-ui/lib/theme-chalk/index.css'
// 引入组件：
// 引入svg-icon图标
import './icons'
// 引入组件css：
import 'vant/lib/index.css'
// 引入rem相关插件
import 'amfe-flexible'
import VuejsDialog from 'vuejs-dialog'
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js' // only needed in custom components

// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// 注册组件：
Vue.use(Vant)
import { Lazyload } from 'vant'
Vue.use(Lazyload)
// Tell Vue to install the plugin.
Vue.use(VuejsDialog)
// Vue.use(ElementUI)
Vue.config.productionTip = false
// router.beforeEach((to, from, next) => {
//   if (window.Login_Title) {
//     document.title = `${window.Login_Title}`
//   } else {
//     document.title = ``
//   }
//   next()
// })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

let $version = document.getElementById('index_webpack_version').value
Vue.prototype.$version = $version.replace('BEGIN_VERSION_', '')
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  let title = '扫码入职'
  const hr = window.location.href
  const str = hr.split('module=')[1]
  let module = 0
  if (str)
  {
    module = str.split('&')[0]
  }
  if (isNaN(Number(module)))
  {
    // 不是数字
    title = window.comm ? window.comm.title : window.title || title
  } else
  {
    // 是数字
    title = window['m' + module]
      ? window['m' + module].title
      : window.title || title
  }
  // if (
  //   ['/home', '/commonPage', '/lecture', '/lectureDetail'].indexOf(
  //     window.location.pathname
  //   ) > -1 &&
  //   window.home_m_tilte
  // )
  //   title = window.home_m_tilte
  document.title = title
  let moduleno = to.query.module
  let test_before_post = true

  const beforePost = window['m' + moduleno]
    ? window['m' + moduleno].test_before_post
    : 1
  if (beforePost == 1)
  {
    test_before_post = true
  } else
  {
    test_before_post = false
  }

  if (from.path === '/seForm' && test_before_post)
  {
    // alert(from.path)
    // Dialog.confirm({
    //   title: '退出',
    //   message: '当前界面未保存，确定退出吗？'
    // })
    //   .then(() => {
    //     setTimeout(() => {
    //       next()
    //     }, 1000)
    //   })
    //   .catch(() => {
    //     setTimeout(() => {
    //       next(false)
    //     }, 1000)
    //   })

    ///// Dialog.confirm 有bug，只能提示1次
    // if (confirm('当前界面未保存，确定退出吗？') == true) {
    //   next()
    // } else {
    //   next(false)
    // }
    Vue.dialog
      .confirm('当前界面未保存，确定退出吗？', {
        okText: '退出',
        cancelText: '取消'
      })
      .then(function (dialog) {
        next()
      })
      .catch(function () {
        next(false)
      })
  } else
  {
    next()
  }
})
